var map = {
	"./Animation - 1708251278640.gif": 1408,
	"./Aquilion-Prime-1.jpg": 8141,
	"./aboutus-bg.jpg": 7602,
	"./aboutus-bg2.jpg": 3650,
	"./bg.jpg": 5150,
	"./career-bg.jpg": 4889,
	"./comprehensive.jpg": 6135,
	"./contactus-bg.jpg": 3579,
	"./logo.png": 2806,
	"./medrad_injector.jpg": 6073,
	"./nemoto_injector.png": 2148,
	"./preventive.jpg": 8571,
	"./product1.jpg": 189,
	"./product2.jpg": 4258,
	"./product3.jpg": 2319,
	"./product4.jpg": 4532,
	"./product5.jpg": 8865,
	"./product6.jpg": 1110,
	"./product7.jpg": 4243,
	"./product8.jpg": 6136,
	"./relocation.jpg": 9797,
	"./review1.webp": 4784,
	"./review2.jpeg": 8290,
	"./review3.jpeg": 8617,
	"./review4.jpeg": 7356,
	"./service-bg.png": 3164,
	"./services.png": 2515,
	"./slider1.jpg": 8663,
	"./slider1.webp": 295,
	"./slider2.jpg": 6088,
	"./slider2.webp": 1046,
	"./slider3.jpg": 6997,
	"./slider4.jpg": 6110,
	"./spare_parts.jpg": 9377,
	"./sticky.jpg": 3254,
	"./weclome_2.png": 6746,
	"./welcome.png": 4839,
	"./work_station_apple.png": 8316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;